export const isValidGedId = (id) => {
    return /^@I\d+@$/.test(id)
}

export const calculateAge = (birthDate) => {
    if (!birthDate) return null
    const today = new Date()
    const birth = new Date(birthDate)
    const hundredYearsAgo = new Date()
    hundredYearsAgo.setFullYear(today.getFullYear() - 100)
    return birth <= hundredYearsAgo
}

export const formatFamilyName = (name) => {
    if (name && name.includes('(')) {
        return name.replace(/\((.*?)\)/, ' ($1) ').trim()
    }
    return name
}

export const formatFullName = (person, language, firstLastName) => {
    if (language === 'en' && person.nameEn && person.lastNameEn) {
        return firstLastName ?
            ` ${person.lastNameEn} ${person.nameEn}` :
            `${person.nameEn} ${person.lastNameEn}`;
    } else {
        const familyNameToUse = person.adminFamilyName || person.familyName;
        return firstLastName ?
            ` ${formatFamilyName(familyNameToUse)} ${person.name}` :
            `${person.name} ${formatFamilyName(familyNameToUse)}`;
    }
};
export const formatNameAncestor = (person, language) => {
        return (language === 'en' && person.nameEn)? `${person.nameEn}` : `${person.name}`;
};